import React from "react";
import Paper from "material-ui/Paper";
import Grid from "material-ui/Grid";
import Typography from "material-ui/Typography";
import Card, { CardContent } from "material-ui/Card";
import { withStyles } from "material-ui/styles";
import styles from "./styles";
import { frequecyMHzToGHz } from "../../../../../../common/utils";

class StatsSubtest extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      classes,
      translate,
      results,
      chartMeasurementUnit,
      subtestResultsDisplay,
      subtest,
      subtestRes,
      job
    } = this.props;

    let isST10GJob = job && (job.deviceid === "signaltek10g");
    if (!isST10GJob && results && results.data) {
      if (results.data.fiberlengthloss && results.data.optical) {
        return (
          <Grid container spacing={0}>
            <Grid xs={12} className={classes.topGridBordered}>
              <Typography className={classes.t_tar_text}>
                {"SFP"}
              </Typography>
              <Typography className={classes.t_tar_no2}>
              {results.data.optical.vendor + " (" + results.data.optical.partnumber + ")"}
              </Typography>
            </Grid>
            <Grid xs={12} className={classes.topGridBordered}>
              <Typography className={classes.t_tar_text}>
                {translate("result_wavelength")}
              </Typography>
              <Typography className={classes.t_tar_no2}>
              {results.data.optical.wavelength }
              </Typography>
            </Grid>
            <Grid xs={12} className={classes.topGridBordered}>
              <Typography className={classes.t_tar_text}>
                {translate("result_rx_pow")}
              </Typography>
              <Typography className={classes.t_tar_no2}>
              {results.data.optical.rxpower }
              </Typography>
            </Grid>
          </Grid>
         );
      }
      else if (results.data.maininterface === "WiFi" && results.data.wifi) {
        let channel_freq_width = results.data.wifi.channel ? results.data.wifi.channel : "-";
        channel_freq_width += " / ";
        channel_freq_width += results.data.wifi.frequency ? (frequecyMHzToGHz(results.data.wifi.frequency) + " GHz") : "-";
        channel_freq_width += " / ";
        channel_freq_width += results.data.wifi.channelwidth ? (results.data.wifi.channelwidth + " MHz") : "-";
        let ssid = results.data.wifi.hidden === true ? translate("hidden_ssid") : results.data.wifi.ssid;
        return (
          <Grid container spacing={0}>
            <Grid xs={12} className={classes.topGridBordered}>
              <Typography className={classes.t_tar_text}>
                {"SSID: " + ssid}
                </Typography>
              <Typography className={classes.t_tar_no2}>
                {"BSSID: " + results.data.wifi.macaddr}
              </Typography>
            </Grid>
            <Grid xs={12} className={classes.topGridBordered}>
              <Typography className={classes.t_tar_text}>
                {translate("channel_frequency_no_units")}
              </Typography>
              <Typography className={classes.t_tar_no2}>
              {channel_freq_width}
              </Typography>
            </Grid>
            <Grid xs={12} className={classes.topGridBordered}>
              <Typography className={classes.t_tar_text}>
                {translate("result_ipv4")}
              </Typography>
              <Typography className={classes.t_tar_no2}>
                {results.data.subtests[subtest] ? results.data.subtests[subtest].ipv4 : "-"}
              </Typography>
            </Grid>
          </Grid>
         );
      }
    }
    return (
      <Grid container spacing={0}>
        <Grid xs={12} className={classes.topGrid}>
          <Typography className={classes.t_tar_text}>
            {isST10GJob ? translate("link_speed_m_r") : translate("result_link_speed")}
          </Typography>
          <Typography className={classes.t_tar_no2}>
            {results.data.subtests &&
            results.data.subtests[subtest] &&
            results.data.subtests[subtest].linkspeedremote
              ? (results.data.subtests[subtest].linkspeedmain
                  ? results.data.subtests[subtest].linkspeedmain
                  : "") +
                "  -  " +
                results.data.subtests[subtest].linkspeedremote
              : results.data.subtests &&
                results.data.subtests[subtest] &&
                results.data.subtests[subtest].linkspeedmain
              ? results.data.subtests[subtest].linkspeedmain
              : ""}
          </Typography>
        </Grid>
        <Grid xs={12} className={classes.topGrid}>
          <Typography className={classes.t_tar_text}>
            {translate("result_macadd")}
            {isST10GJob ? translate("result_macadd_mr") : ""}
          </Typography>
          <Typography className={classes.t_tar_no2}>
            {results.data.subtests[subtest] &&
            results.data.subtests[subtest].dhmacaddress
              ? results.data.subtests[subtest].dhmacaddress + " "
              : ""}
            {isST10GJob ? "-" : ""}
            {isST10GJob && results.data.subtests[subtest] &&
            results.data.subtests[subtest].rhmacaddress
              ? " " + results.data.subtests[subtest].rhmacaddress
              : ""}
          </Typography>
        </Grid>
        <Grid xs={12} className={classes.topGrid}>
          <Typography className={classes.t_tar_text}>
            {translate("result_ipv4")}
          </Typography>
          <Typography className={classes.t_tar_no2}>
            {results.data.subtests[subtest] &&
              results.data.subtests[subtest].ipv4}
          </Typography>
        </Grid>
        <Grid xs={12} className={classes.topGrid}>
          <Typography className={classes.t_tar_text}>
            {translate("result_ipv6")}
          </Typography>
          <Typography className={classes.t_tar_no2}>
            {results.data.subtests[subtest] &&
              results.data.subtests[subtest].ipv6}
          </Typography>
        </Grid>
      </Grid>
    );
  }
}

export default withStyles(styles)(StatsSubtest);
